import _ from "lodash";
import React from "react";

import { Tag } from "@toddle-edu/ds-web";
import { FolderFilled } from "@toddle-edu/ds-icons";

import classes from "./TaggedFolders.scss";

const TaggedFolders = React.memo(props => {
  const {
    folders,
    containerStyle = {},
    singleTagContainerStyle = {},
    singleTagTextStyle = {},
    tagSize = "x-small",
    showFolderIcon = false,
  } = props;

  if (_.isEmpty(folders)) return null;

  return (
    <div className={classes.folderTagsContainer} style={containerStyle}>
      {_.map(folders, folder => {
        return (
          <div
            className={classes.folderTag}
            style={singleTagContainerStyle}
            key={_.get(folder, "id", _.get(folder, "name"))}
          >
            <Tag
              size={tagSize}
              prefix={
                showFolderIcon ? (
                  <FolderFilled
                    style={{ color: folder?.color, flexShrink: 0 }}
                    size="x-small"
                  />
                ) : null
              }
            >
              <span style={singleTagTextStyle}>{folder.name}</span>
            </Tag>
          </div>
        );
      })}
    </div>
  );
});
TaggedFolders.displayName = "TaggedFolders";

export default TaggedFolders;
